namespace TotalPoll {
    import IRootScopeService = angular.IRootScopeService;
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'question-component-template',
        bindings: {
            item: '=',
            index: '=',
            onDelete: '&',
        }
    })
    class QuestionComponent {
        public index: number;
        public item;

        constructor(public $rootScope: IRootScopeService) {

        }

        $onInit() {

        }

        checkSettings() {
            this.item.settings.selection.minimum = Math.abs(parseInt(this.item.settings.selection.minimum)) || 0;
            this.item.settings.selection.maximum = Math.abs(parseInt(this.item.settings.selection.maximum)) || 1;

            if (this.item.choices.length) {
                if (this.item.settings.selection.minimum > this.item.choices.length) {
                    this.item.settings.selection.minimum = this.item.choices.length;
                }

                if (this.item.settings.selection.maximum > this.item.choices.length) {
                    this.item.settings.selection.maximum = this.item.choices.length;

                }
            }

            if (this.item.settings.selection.minimum > this.item.settings.selection.maximum) {
                this.item.settings.selection.minimum = this.item.settings.selection.maximum;
            }
        }

        prefix(content, separator = '-') {
            return `${content}${separator}${this.item.uid}`;
        }

        suffix(content, separator = '-') {
            return `${this.item.uid}${separator}${content}`;
        }
    }
}